import { KitContract } from '../../kits/domain/contracts/kit_contract';
import { kitIndexEntity } from '../../kits/domain/entities/kit_index_entity';
import http from "../../../plugins/http-common"
import i18n from "../../../i18n"

export const HttpKitRepository = {
  ...KitContract,
  model_index: kitIndexEntity,

  async index(page, per_page, search, sort_by) {
    var sort = ""

    if (sort_by.length > 0) sort = '&sort=' + sort_by[0].field + '&sort_direction=' + sort_by[0].direction;
    const res = await http.get('kits?page=' + page + '&per_page=' + per_page + '&search=' + search + sort);

    for(let i = 0; i < res.data.data.length; i++) {
      res.data.data[i] = res.data.data[i].attributes;
      
      res.data.data[i].actions = JSON.parse(JSON.stringify([
        {
            name: i18n.t('kits.details'),
            icon: {
                color: 'accent',
                icon: 'info'
            },
            link: 'kits/details/' + res.data.data[i].id,
            permission: 'kit.show|kit_detail.show'
        },
        {
            name: i18n.t('kits.edit'),
            icon: {
                color: 'accent',
                icon: 'edit'
            },
            link: 'kits/edit/' + res.data.data[i].id,
            permission: 'kit.update|kit_detail.update'
        },
        {
            name: i18n.t('kits.delete'),
            icon: {
                color: 'accent',
                icon: 'delete'
            },
            method: 'askDelete',
            permission: 'kit.delete|kit_detail.delete'
        }
      ]));

      res.data.data[i].parameters = res.data.data[i].id;
    }

    return res;
  },
};